export default __webpack_public_path__ + "static/media/Lab_Management.3a3d19c3.png";